import {
  CREATE_FEEDBACK,
  CREATE_FEEDBACK_COMPLETE,
} from "./types";

export const initialState = {
   submittingFeedback: false
};

export const feedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_FEEDBACK:
            return ({ submittingFeedback: true });
        case CREATE_FEEDBACK_COMPLETE:
            return ({
                submittingFeedback: false
            })

        default:
            return state;
    }
}
